module.exports = __webpack_public_path__ + "static/img/car1.bc7b5e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car1.png
// module id = 0PyM
// module chunks = 1